import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BatchTransactionsPage } from './batch-transactions.page';

const routes: Routes = [
  {
    path: '',
    component: BatchTransactionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BatchTransactionsPageRoutingModule {}
